import { useState, useEffect } from 'react';

import Attribution from './Attribution';
import CallToAction from './CallToAction';

import { useQuery } from '@tanstack/react-query';
import { client } from '../../prismic';
import { PrismicRichText } from '@prismicio/react';

import './styles/About.scss';
import './styles/About-mobile.scss';

const About = () => {
  const [about, setAbout] = useState(new AboutData());
  let { data } = useQuery({
    queryKey: ['aboutData'],
    queryFn: () => client.getAllByType('about_me'),
  });

  useEffect(() => {
    const aboutIsUnset = about.profilePicture === '';

    if (aboutIsUnset && data) {
      const filtered = new AboutData();
      const d = data[0].data;

      filtered.profilePicture = d.profile_picture;
      filtered.aboutText = d.about_text;

      filtered.bottomImage = d.bottom_image;
      filtered.callToActionText = d.call_to_action_text;

      setAbout(filtered);
    }
  }, [data, about.profilePicture]);

  return (
    <div className='about-me-wrapper'>
      <div id='about-me'>
        <div className='profile-picture-container'>
          <img src={about.profilePicture.url} alt={about.profilePicture.alt} />
        </div>
        <h1>ABOUT ME</h1>
        <PrismicRichText field={about.aboutText} />
      </div>
      <CallToAction banner={about.bottomImage.url}>
        <PrismicRichText field={about.callToActionText} />
      </CallToAction>
      <Attribution />
    </div>
  );
};

class AboutData {
  aboutText = [];
  profilePicture = '';
  process1Text = [];
  process1Title = [];
  process1Image = '';
  process2Title = [];
  process2Text = [];
  process2Image = '';
  process3Title = [];
  process3Text = [];
  process3Image = '';
  bottomImage = '';
}

export default About;
